import reduxKeys from "../../constants/reduxKeys";
import { formatListItems } from "../../utils";

 // reducers.js
const initialState = {
    installers: []
}

  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case reduxKeys.SET_INSTALLERS:
        const list = formatListItems(action.payload, "installerId", "name");
        return { ...state, installers: list };
      default:
        return state;
    }
  };

  export default reducer;